import React, { useEffect, useRef, useState } from "react";
import { Modal, message, Button } from "antd";
import Cookies from "js-cookie";
import { format } from "date-fns";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import FolderIcon from "@mui/icons-material/Folder";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import HourglassDisabledIcon from "@mui/icons-material/HourglassDisabled";
import * as XLSX from "xlsx";
import Tour from "reactour";

const DocumentVault = () => {
  const [sortBy, setSortBy] = useState("default");
  const [documents, setDocuments] = useState([]);
  const [folders, setFolders] = useState([]);
  const [sorteddocuments, setSortedDocuments] = useState([]);
  const [openedId, setOpenedId] = useState("");
  const [openedFolders, setOpenFolders] = useState(null);
  const [financialSummary, setFinancialSummary] = useState([]);
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [exportcsvIsOpen, setExportCsvIsOpen] = useState(false);
  const [openedTab, setOpenTab] = useState(1);
  const fileInputRef = useRef(null);
  const [isTourOpen2, setIsTourOpen2] = useState(false);
  const [isSampleData, setIsSampleData] = useState(false);

  const tourSteps = [
    {
      selector: ".stepssss1",
      content:
        "Access uploaded documents and add new or existing loan offer letters to monitor your loan.",
    },
    {
      selector: ".stepssss2",
      content:
        "Get your loan summary instantly for financial reporting - Skip the bank calls",
    },
    {
      selector: ".stepssss3",
      content:
        "Quickly view all your loans balance, installment, and progress toward your final payment—no more missed deadlines.",
    },
    {
      selector: ".stepssss4",
      content:
        "Upload your loan offer letter from any lenders—our AI will process it and update your dashboard within 24 hours!",
    },
  ];

  const handleButtonClick = () => {
    fileInputRef.current.click(); // Trigger the hidden input click
  };
  function groupFilesByFileId(files) {
    const groupedFiles = { Platform: [] };

    files.forEach((file) => {
      if (file.type === null) {
        groupedFiles["Platform"].push(file);
      } else {
        if (!groupedFiles[file.file_id]) {
          groupedFiles[file.file_id] = [];
        }
        groupedFiles[file.file_id].push(file);
      }
    });

    return groupedFiles;
  }

  const [myFinancialSummary, setMyFinancialSummary] = useState(null);

  const [financialSummaryMonth, setFinancialSummaryMonth] = useState(null);

  const [currentDisplayMonth, setCurrentDisplayMonth] = useState("");

  const [openLoanData, setOpenLoanData] = useState(null);
  const columnOptions = [
    { label: "Lender", key: "Lender" },
    { label: "Type of Facility", key: "Type of Facility" },
    { label: "Facility Limit", key: "Facility Limit" },
    { label: "Tenor", key: "Tenor" },
    { label: "Interest Rate", key: "Interest Rate" },
    { label: "Processing Fee", key: "Processing Fee" },
    { label: "Disbursement Date", key: "Disbursement Date" },
    { label: "Monthly Installment", key: "Monthly Installment" },
    { label: "Remaining Tenor (months)", key: "Remaining Tenor (months)" },
    { label: "Outstanding Balance", key: "Outstanding Balance" },
  ];

  const [selectedColumns, setSelectedColumns] = useState(
    columnOptions.map((col) => col.key) // all selected by default
  );

  const exportToExcel = () => {
    if (!myFinancialSummary || myFinancialSummary.length === 0) return;

    const today = new Date();

    const processedData = myFinancialSummary.financial_summary.map(
      ({
        lender,
        typeoffacility,
        facilitylimit,
        tenor,
        interestrate,
        processingfee,
        disbursementdate,
        monthylyinstallment,
      }) => {
        const tenorMatch = tenor.match(/\d+/);
        const totalTenorMonths = tenorMatch ? parseInt(tenorMatch[0], 10) : 0;

        const disburseDate = new Date(disbursementdate);
        const firstInstallmentDate = new Date(disburseDate);
        firstInstallmentDate.setMonth(disburseDate.getMonth() + 1);

        let remainingTenor = 0;
        if (today < firstInstallmentDate) {
          remainingTenor = totalTenorMonths;
        } else {
          const monthsElapsed =
            (today.getFullYear() - firstInstallmentDate.getFullYear()) * 12 +
            (today.getMonth() - firstInstallmentDate.getMonth());

          remainingTenor = Math.max(0, totalTenorMonths - monthsElapsed);
        }

        const installmentAmount = parseFloat(
          monthylyinstallment.replace(/[^\d.-]/g, "")
        );
        const outstandingBalance = installmentAmount * remainingTenor;

        // All possible data
        const fullData = {
          Lender: lender,
          "Type of Facility": typeoffacility,
          "Facility Limit": facilitylimit,
          Tenor: tenor,
          "Interest Rate": interestrate,
          "Processing Fee": processingfee,
          "Disbursement Date": formatDate(disbursementdate),
          "Monthly Installment": monthylyinstallment,
          "Remaining Tenor (months)": `${remainingTenor} Months`,
          "Outstanding Balance": `S$ ${outstandingBalance.toLocaleString(
            "en-SG",
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }
          )}`,
        };

        // Return only selected keys
        const filteredData = {};
        selectedColumns.forEach((key) => {
          filteredData[key] = fullData[key];
        });

        return filteredData;
      }
    );

    const worksheet = XLSX.utils.json_to_sheet(processedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Loan Data");
    XLSX.writeFile(workbook, "loan_data.xlsx");
  };
  const [currentMonth, setCurrentMonth] = useState("");

  useEffect(() => {
    const now = new Date();
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const month = monthNames[now.getMonth()];
    const year = now.getFullYear();

    const formatted = `${month} ${year}`;
    // console.log(formatted);
    setCurrentDisplayMonth(formatted);
    setCurrentMonth(formatted);
  }, []);

  const getInitials = (name) => {
    const textToSplit = name.split(" ");
    const initials =
      textToSplit?.[0]?.[0].toUpperCase() +
      (textToSplit?.[1]?.[0].toUpperCase() || "");
    return initials;
  };

  const [currentLoanData, setCurrentLoanData] = useState(null);

  const calculateLoanStats = (adjustingData) => {
    const today = new Date();

    let totalOutstanding = 0;
    let totalPaid = 0;
    let totalLoanAmount = 0;

    adjustingData.forEach((loan) => {
      const disbursementDate = new Date(loan.disbursementdate);
      const tenorInMonths = parseInt(loan.tenor.match(/\d+/)?.[0] || "0", 10);
      const monthlyAmount =
        parseFloat(loan.monthylyinstallment.replace(/[^\d.]/g, "")) || 0;

      // First payment is one month after disbursement
      const firstPaymentDate = new Date(disbursementDate);
      firstPaymentDate.setMonth(firstPaymentDate.getMonth() + 1);

      // Calculate how many months have passed since first payment
      const monthsPaid = Math.max(
        0,
        Math.min(
          tenorInMonths,
          (today.getFullYear() - firstPaymentDate.getFullYear()) * 12 +
            (today.getMonth() - firstPaymentDate.getMonth()) +
            (today.getDate() >= firstPaymentDate.getDate() ? 0 : -1)
        )
      );

      const paidAmount = monthsPaid * monthlyAmount;
      const remainingAmount = (tenorInMonths - monthsPaid) * monthlyAmount;
      const totalLoanForThis = tenorInMonths * monthlyAmount;

      totalPaid += paidAmount;
      totalOutstanding += remainingAmount;
      totalLoanAmount += totalLoanForThis;
    });

    const percentageRemaining =
      totalLoanAmount > 0
        ? ((totalPaid / totalLoanAmount) * 100).toFixed(2)
        : "0.00";

    // console.log({
    //   total_loan_amount: `S$ ${totalLoanAmount.toLocaleString(undefined, {
    //     minimumFractionDigits: 2,
    //   })}`,
    //   total_paid_off_amount: `S$ ${totalPaid.toLocaleString(undefined, {
    //     minimumFractionDigits: 2,
    //   })}`,
    //   total_loan_outstanding: `S$ ${totalOutstanding.toLocaleString(undefined, {
    //     minimumFractionDigits: 2,
    //   })}`,
    //   percentage_of_loan_remaining: `${percentageRemaining}%`,
    // });

    setCurrentLoanData({
      total_loan_amount: `S$ ${totalLoanAmount.toLocaleString(undefined, {
        minimumFractionDigits: 2,
      })}`,
      total_paid_off_amount: `S$ ${totalPaid.toLocaleString(undefined, {
        minimumFractionDigits: 2,
      })}`,
      total_loan_outstanding: `S$ ${totalOutstanding.toLocaleString(undefined, {
        minimumFractionDigits: 2,
      })}`,
      percentage_of_loan_remaining: `${percentageRemaining}%`,
    });
  };

  const getMyFinancialSummary = async () => {
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/user/getMyFinancialSummary`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      if (response.ok) {
        const json = await response.json();
        if (!json.data && json.platform_loans.length < 1) {
          setIsSampleData(true);
          const adjustingData = { financial_summary: [] };
          let dataToPush = {};
          dataToPush.lender = "Sample Lender";
          dataToPush.typeoffacility = "B2B loan";
          dataToPush.facilitylimit = `S$ 50,000.00`;
          dataToPush.tenor = `5 Months`;
          dataToPush.interestrate = `3.8% (p.m)`;
          dataToPush.processingfee = `5%`;
          dataToPush.disbursementdate = `2025-02-09`;
          dataToPush.monthylyinstallment = `S$ 10,000.00`;
          adjustingData.financial_summary.push(dataToPush);
          calculateLoanStats(adjustingData.financial_summary);
          setMyFinancialSummary(adjustingData);

          const groupedByMonth = {};

          adjustingData.financial_summary.forEach((loan) => {
            const disburseDate = new Date(loan.disbursementdate);

            // Get number of months from tenor string (e.g., "6 Months")
            const tenorMatch = loan.tenor.match(/\d+/);
            const months = tenorMatch ? parseInt(tenorMatch[0], 10) : 0;

            const disbursementDay = disburseDate.getDate(); // e.g., 31st

            for (let i = 1; i <= months; i++) {
              const installmentDate = new Date(disburseDate);
              installmentDate.setMonth(installmentDate.getMonth() + i);

              // Create the target due date
              let dueDate = new Date(
                installmentDate.getFullYear(),
                installmentDate.getMonth(),
                disbursementDay
              );

              // Fix invalid dates (like Feb 31 → Mar 2, which we don’t want)
              if (dueDate.getMonth() !== installmentDate.getMonth()) {
                // Set to last day of the correct month
                dueDate = new Date(
                  installmentDate.getFullYear(),
                  installmentDate.getMonth() + 1,
                  0
                );
              }

              const month = installmentDate.toLocaleString("default", {
                month: "long",
              });
              const year = installmentDate.getFullYear();
              const key = `${month} ${year}`;

              if (!groupedByMonth[key]) {
                groupedByMonth[key] = [];
              }

              const monthlyAmount =
                parseFloat(loan.monthylyinstallment.replace(/[^\d.]/g, "")) ||
                0;

              const tenorInMonths = parseInt(
                loan.tenor.match(/\d+/)?.[0] || "0",
                10
              );
              groupedByMonth[key].push({
                ...loan,
                paidRepayment: (tenorInMonths - i) * monthlyAmount,
                currentRepayment: `${i} of ${months}`,
                dueDate: dueDate.toISOString().split("T")[0], // Format: YYYY-MM-DD
              });
            }
          });
          const monthMap = {
            January: 0,
            February: 1,
            March: 2,
            April: 3,
            May: 4,
            June: 5,
            July: 6,
            August: 7,
            September: 8,
            October: 9,
            November: 10,
            December: 11,
          };

          const sortedEntries = Object.entries(groupedByMonth).sort(
            ([keyA], [keyB]) => {
              const [monthA, yearA] = keyA.split(" ");
              const [monthB, yearB] = keyB.split(" ");

              const dateA = new Date(parseInt(yearA), monthMap[monthA]);
              const dateB = new Date(parseInt(yearB), monthMap[monthB]);

              return dateA - dateB;
            }
          );

          const sortedGroupedByMonth = Object.fromEntries(sortedEntries);

          // console.log(sortedGroupedByMonth);
          setFinancialSummaryMonth(sortedGroupedByMonth);
        } else {
          const adjustingData = { ...json.data };
          adjustingData.financial_summary = json.data
            ? JSON.parse(json.data.financial_summary)
            : [];
          const dataToInsetTOAdjustingData = [...json.platform_loans];
          dataToInsetTOAdjustingData.forEach((dat) => {
            let dataToPush = {};
            dataToPush.lender = dat.principal_name
              ? dat.principal_name
              : dat.lender_id;
            dataToPush.typeoffacility = "B2B SmartLend";
            dataToPush.facilitylimit = `S$ ${dat.principal.toLocaleString(
              "en-SG",
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }
            )}`;
            dataToPush.tenor = `${dat.period} Months`;
            dataToPush.interestrate = `${dat.interest_rate * 100}% (p.m)`;
            dataToPush.processingfee = `${dat.processing_fee * 100}%`;
            dataToPush.disbursementdate = `${dat.created_at.slice(0, 10)}`;
            dataToPush.monthylyinstallment = `S$ ${dat.monthly_installment.toLocaleString(
              "en-SG",
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }
            )}`;
            dataToPush.bankBool = dat.bankBool;
            dataToPush.loanType = dat.loanType;
            adjustingData.financial_summary.push(dataToPush);
          });
          calculateLoanStats(adjustingData.financial_summary);
          setMyFinancialSummary(adjustingData);
          console.log(adjustingData.financial_summary);
          const groupedByMonth = {};

          adjustingData.financial_summary.forEach((loan) => {
            const disburseDate = new Date(loan.disbursementdate);
            const tenorMatch = loan.tenor.match(/\d+/);
            const months = tenorMatch ? parseInt(tenorMatch[0], 10) : 0;
            const disbursementDay = disburseDate.getDate();
          
            const monthlyAmount =
              parseFloat(loan.monthylyinstallment.replace(/[^\d.]/g, "")) || 0;
            const initialBalance =
              parseFloat(loan.facilitylimit.replace(/[^\d.]/g, "")) || 0;
            const interestRate =
              parseFloat(loan.interestrate.replace(/[^\d.]/g, "")) || 0;
            const isBankLoan = loan.bankbool === "Bank Loan";
          
            let balance = initialBalance;
            let totalPaid = 0;
          
            for (let i = 1; i <= months; i++) {
              const targetMonth = disburseDate.getMonth() + i;
              const targetYear = disburseDate.getFullYear() + Math.floor(targetMonth / 12);
              const normalizedMonth = targetMonth % 12;
          
              // Try to create the due date with the original day
              let dueDate = new Date(targetYear, normalizedMonth, disbursementDay);
          
              // If the day overflows into the next month, fix to last day of target month
              if (dueDate.getMonth() !== normalizedMonth) {
                dueDate = new Date(targetYear, normalizedMonth + 1, 0); // 0 gives last day of previous month
              }
          
              const month = dueDate.toLocaleString("default", { month: "long" });
              const year = dueDate.getFullYear();
              const key = `${month} ${year}`;
          
              if (!groupedByMonth[key]) {
                groupedByMonth[key] = [];
              }
          
              let interestPaid = 0;
              let principalPaid = 0;
              let paidRepayment = 0;
              let currentPrincipalBalance = 0;
          
              if (isBankLoan) {
                const monthlyRate = interestRate / 100 / 12;
                interestPaid = balance * monthlyRate;
                principalPaid = monthlyAmount - interestPaid;
                currentPrincipalBalance = balance - principalPaid;
                balance = currentPrincipalBalance;
                totalPaid += monthlyAmount;
                paidRepayment = totalPaid;
              } else {
                paidRepayment = (months - i) * monthlyAmount;
              }
          
              groupedByMonth[key].push({
                ...loan,
                paidRepayment: parseFloat(paidRepayment.toFixed(2)),
                currentRepayment: `${i} of ${months}`,
                dueDate: dueDate.toISOString().split("T")[0],
                remainingBalance: isBankLoan
                  ? parseFloat(currentPrincipalBalance.toFixed(2))
                  : undefined,
                interestPaid: isBankLoan
                  ? parseFloat(interestPaid.toFixed(2))
                  : undefined,
                principalPaid: isBankLoan
                  ? parseFloat(principalPaid.toFixed(2))
                  : undefined,
              });
            }
          });
          
          

          const monthMap = {
            January: 0,
            February: 1,
            March: 2,
            April: 3,
            May: 4,
            June: 5,
            July: 6,
            August: 7,
            September: 8,
            October: 9,
            November: 10,
            December: 11,
          };

          console.log(groupedByMonth)
          const sortedEntries = Object.entries(groupedByMonth).sort(
            ([keyA], [keyB]) => {
              const [monthA, yearA] = keyA.split(" ");
              const [monthB, yearB] = keyB.split(" ");

              const dateA = new Date(parseInt(yearA), monthMap[monthA]);
              const dateB = new Date(parseInt(yearB), monthMap[monthB]);

              return dateA - dateB;
            }
          );

          const sortedGroupedByMonth = Object.fromEntries(sortedEntries);

          // console.log(sortedGroupedByMonth);
          setFinancialSummaryMonth(sortedGroupedByMonth);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getMyFinancialSummary();
  }, []);

  const getAllDocument = async () => {
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/file/geAllDocumentVault`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      if (response.ok) {
        const json = await response.json();
        setFolders(groupFilesByFileId(json.data));
        // setDocuments(json.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const UniversaleUploadFile = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", "Manual");
    formData.append("file_id", "User");
    // console.log(file);
    try {
      const response1 = await fetch(
        "https://www.smart-lend.com/api/file/uploadUniversalFile",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: formData,
        }
      );
      if (response1.status === 200) {
        const data = await response1.json();
        const blobUrl = data.url;
        getAllDocument();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-"; // Return a default value if the date string is not provided

    const date = new Date(dateString); // Create a Date object from the date string
    const formattedDate = format(date, "dd MMMM yyyy"); // Use date-fns to format the date in the desired format

    return formattedDate;
  };

  useEffect(() => {
    getAllDocument();
  }, []);

  useEffect(() => {
    setIsTourOpen(true);
  }, []);

  useEffect(() => {
    let sortedDocs = [...documents];

    if (sortBy === "name") {
      sortedDocs.sort((a, b) => a.file_name.localeCompare(b.file_name));
    } else if (sortBy === "type") {
      sortedDocs.sort((a, b) => {
        const getFileExtension = (fileName) => {
          const parts = fileName.split(".");
          return parts.length > 1 ? parts.pop().toLowerCase() : "unknown"; // Handle files with no extension
        };

        return getFileExtension(a.file_name).localeCompare(
          getFileExtension(b.file_name)
        );
      });
    } else {
      sortedDocs.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      ); // Newest first
    }

    setSortedDocuments(sortedDocs);
  }, [documents, sortBy]);

  return (
    <div
      style={{
        width: window.innerWidth < 1200 ? "100%" : "calc(100% - 40px)",
        marginLeft: window.innerWidth < 1200 ? "0px" : "20px",
        position: "relative",
        display: "flex",
        overflowY: "auto",
        color: "var(--br-text, #142C44CC)",
        height: window.innerHeight * 0.9,
        gap: "15px",
      }}
    >
      <Modal
        style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
        open={exportcsvIsOpen}
        onCancel={() => {
          setExportCsvIsOpen(false);
        }}
        width={"60vh"}
        footer={null}
      >
        <div
          style={{
            color: "var(--br-text, #142C44CC)",
            fontFamily: "Manrope,sans-serif",
            fontWeight: "800",
            fontSize: "24px",
          }}
        >
          CSV Export
        </div>
        <div
          style={{
            color: "var(--br-text, #142C44CC)",
            fontFamily: "Manrope,sans-serif",
            fontWeight: "500",
            fontSize: "12px",
          }}
        >
          Please select the columns you would like to export.
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            marginTop: "15px",
            color: "var(--br-text, #142C44CC)",
            fontFamily: "Manrope,sans-serif",
            fontWeight: "500",
            fontSize: "12px",
          }}
        >
          {columnOptions.map((col) => (
            <div style={{ width: "33%" }}>
              <label key={col.key}>
                <input
                  type="checkbox"
                  checked={selectedColumns.includes(col.key)}
                  onChange={(e) => {
                    setSelectedColumns((prev) =>
                      e.target.checked
                        ? [...prev, col.key]
                        : prev.filter((k) => k !== col.key)
                    );
                  }}
                />
                {col.label}
              </label>
            </div>
          ))}
        </div>
        <div
          className="mui_button"
          style={{
            background: "var(--br-primary, rgb(14, 90, 165))",
            color: "white",
            fontWeight: 500,
            fontSize: "14px",
            padding: "5px 15px",
            borderRadius: "7px",
            textAlign: "center",
            cursor: "pointer",
            marginTop: "20px",
          }}
          onClick={() => {
            setExportCsvIsOpen(false);
            exportToExcel();
          }}
        >
          Export
        </div>
      </Modal>
      <Modal
        style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
        open={openLoanData !== null}
        onCancel={() => {
          setOpenLoanData(null);
        }}
        width={"60vh"}
        footer={null}
      >
        {openLoanData ? (
          <div
            style={{
              color: "var(--br-text, #142C44CC)",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                width: "100%",
                borderBottom: "1px solid #142C442A",
                paddingBottom: "15px",
              }}
            >
              <div
                style={{
                  background: "rgba(var(--br-primary-rgb, 112,87,246), 0.6039215686274509)",
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "50px",
                  height: "50px",
                  borderRadius: "7px",
                }}
              >
                {getInitials(openLoanData.lender)}
              </div>
              <div style={{ textAlign: "left" }}>
                <div style={{ fontSize: "16px", fontWeight: 600 }}>
                  {openLoanData.lender}
                </div>
                <div>{openLoanData.typeoffacility}</div>
              </div>
            </div>
            <div style={{ display: "flex", marginTop: "15px" }}>
              <div style={{ width: "50%" }}>
                <div style={{ fontSize: "12px", opacity: 0.4 }}>
                  Loan Amount
                </div>
                <div>{openLoanData.facilitylimit}</div>
              </div>
              <div style={{ width: "50%" }}>
                <div style={{ fontSize: "12px", opacity: 0.4 }}>Loan Tenor</div>
                <div>{openLoanData.tenor}</div>
              </div>
            </div>
            <div style={{ display: "flex", marginTop: "10px" }}>
              <div style={{ width: "50%" }}>
                <div style={{ fontSize: "12px", opacity: 0.4 }}>
                  Interest Rate
                </div>
                <div>{openLoanData.interestrate}</div>
              </div>
              <div style={{ width: "50%" }}>
                <div style={{ fontSize: "12px", opacity: 0.4 }}>
                  Processing Fee
                </div>
                <div>{openLoanData.processingfee}</div>
              </div>
            </div>
            <div style={{ display: "flex", marginTop: "10px" }}>
              <div style={{ width: "50%" }}>
                <div style={{ fontSize: "12px", opacity: 0.4 }}>
                  Disbursement Date
                </div>
                <div>{openLoanData.disbursementdate}</div>
              </div>
              <div style={{ width: "50%" }}>
                <div style={{ fontSize: "12px", opacity: 0.4 }}>
                  Monthly Installment
                </div>
                <div>{openLoanData.monthylyinstallment}</div>
              </div>
            </div>
            <div style={{ display: "flex", marginTop: "10px" }}>
              <div style={{ width: "50%" }}>
                <div style={{ fontSize: "12px", opacity: 0.4 }}>Due Date</div>
                <div>{formatDate(openLoanData.dueDate)}</div>
              </div>
              <div style={{ width: "50%" }}>
                <div style={{ fontSize: "12px", opacity: 0.4 }}>
                  Current Repayment
                </div>
                <div>{openLoanData.currentRepayment}</div>
              </div>
            </div>
          </div>
        ) : null}
      </Modal>
      <Modal
        style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
        open={isTourOpen}
        onCancel={() => {
          setIsTourOpen(false);
          setIsTourOpen2(true);
        }}
        width={"60vh"}
        footer={null}
      >
        <div
          style={{
            color: "grey",
            fontFamily: "Manrope,sans-serif",
            fontWeight: "500",
            fontSize: "16px",
          }}
        >
          <div
            style={{
              color: "var(--br-text, #142C44CC)",
              fontFamily: "Manrope,sans-serif",
              fontWeight: "800",
              fontSize: "30px",
            }}
          >
            Unlock Your Financial Control!
          </div>
          <div style={{ marginTop: "15px" }}>
            Say goodbye to Loan Document chaos. Effortlessly access all your
            loans from multiple lenders in one place. Lost track of your loan
            offer letters or installment dates? Simply upload your offers to
            consolidate every loan commitment across all lenders in Singapore.
          </div>
          <div style={{ marginTop: "15px" }}>
            ✨ Stay on top of your company’s finances with real-time tracking,
            progress monitoring, and complete control.
          </div>
          <div style={{ marginTop: "15px" }}>
            {" "}
            Ready to experience seamless financial management?
          </div>
          <div style={{ marginTop: "20px", display: "flex" }}>
            <div
              className="mui_button"
              style={{
                borderRadius: "var(--br-card-radius, 20px)",
                fontSize: "14px",
                fontWeight: "700",
                fontFamily: "Poppins, sans-serif",
                padding: "8px",
                background: "var(--br-primary, rgb(14, 90, 165))",
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
              }}
              onClick={() => {
                setIsTourOpen(false);
                setIsTourOpen2(true);
              }}
            >
              <div
                style={{
                  marginLeft: "20px",
                  marginRight: "10px",
                }}
              >
                Get Started
              </div>
              <div
                style={{
                  width: "25px",
                  height: "25px",
                  borderRadius: "50%",
                  background: "var(--br-surface, white)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <NavigateNextIcon
                  style={{
                    color: "var(--br-primary, rgb(14, 90, 165))",
                    fontSize: "24px",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <div style={{ width: "100%" }}>
        <div
          style={{
            height: "50px",
            width: "100%",
            display: "flex",
            position: "relative",
            gap: "10px",
            color: "var(--br-text, #142C44CC)",
            fontWeight: 600,
          }}
        >
          <div
            style={{
              position: "relative",
              zIndex: 5,
              height: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "200px",
              background: "rgba(256,256,256,0.2)",
              borderRadius: "var(--br-card-radius, 8px)",
              cursor: "pointer",
            }}
            onClick={() => {
              setOpenTab(1);
            }}
          >
            Financial Summary
          </div>
          <div
            style={{
              position: "relative",
              zIndex: 5,
              height: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "200px",
              background: "rgba(256,256,256,0.2)",
              borderRadius: "var(--br-card-radius, 8px)",
              cursor: "pointer",
            }}
            className="stepssss1"
            onClick={() => {
              setOpenTab(0);
            }}
          >
            Document Vault
          </div>
          <div
            style={{
              background: "rgb(256,256,256)",
              position: "absolute",
              left: openedTab === 1 ? "0px" : "210px",
              zIndex: 4,
              top: 0,
              width: "200px",
              background: "rgba(256,256,256,0.2)",
              borderRadius: "var(--br-card-radius, 8px)",
              height: "40px",
              boxShadow: "var(--br-shadow, 10px 10px 10px rgba(0,0,0,0.2))",
              transition: "0.3s all ease-in-out",
            }}
          />
        </div>
        {openedTab === 0 ? (
          <div
            style={{
              width: "100%",
              background:
                window.innerWidth < 1200
                  ? "transparent"
                  : "var(--br-card-surface, transparent linear-gradient(180deg, #FFFFFFB3 0%, #FFFFFF00 100%) 0% 0% no-repeat padding-box)",
              borderRadius: "var(--br-card-radius, 10px)",
              marginTop: "5px",
              gap: "5px",
              padding: "20px",
              height:
                window.innerWidth < 1200
                  ? `calc(${window.innerHeight}px - 130px)`
                  : "calc(100% - 130px)",
            }}
          >
            <div
              style={{
                color: "var(--br-text, #142C44CC)",
                fontFamily: "Manrope,sans-serif",
                fontWeight: "800",
                fontSize: "18px",
                display: "flex",
                alignItems: "center",
                marginBottom: "10px",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              {openedFolders === null ? (
                window.innerWidth < 1200 ? (
                  "Documents"
                ) : (
                  "Document Vault"
                )
              ) : (
                <div
                  style={{ display: "flex", cursor: "pointer" }}
                  onClick={() => {
                    setOpenedId("");
                    setOpenFolders(null);
                  }}
                >
                  <div>
                    <ArrowBackIosIcon style={{ color: "var(--br-text, #142C44CC)" }} />
                  </div>
                  {openedId}
                </div>
              )}
              <div style={{ display: "flex" }}>
                <input
                  onChange={(e) => {
                    UniversaleUploadFile(e.target.files[0]);
                  }}
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  type="file"
                />
                <div
                  className="stepssss4"
                  onClick={handleButtonClick}
                  style={{
                    color: "var(--br-primary, rgb(14, 90, 165))",
                    border: "2px solid var(--br-primary, rgb(14, 90, 165))",
                    fontWeight: 500,
                    fontSize: "14px",
                    padding: "5px 15px",
                    borderRadius: "7px",
                    marginLeft: "10px",
                    textAlign: "center",
                    cursor: "pointer",
                  }}
                >
                  Upload
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "10px",
                maxHeight:
                  sorteddocuments && sorteddocuments.length > 0
                    ? "100%"
                    : "100%",
                width: "100%",
                overflowY: "auto",
                alignItems: "flex-start",
                justifyContent: "flex-start",
              }}
            >
              {openedFolders === null
                ? Object.entries(folders).map(([fileId, fileGroup]) => (
                    <div
                      key={fileId}
                      className="border_change_hover"
                      onClick={() => {
                        setOpenFolders(fileGroup);
                        setOpenedId(fileId);
                      }}
                      style={{
                        padding: "20px",
                        borderRadius: "8px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        width:
                          window.innerWidth < 1200
                            ? `${window.innerWidth / 2 - 30}px`
                            : "120px",
                        height: "120px",
                        textAlign: "center",
                        border: "1px solid rgba(var(--br-primary-rgb, 112,87,246), 0.22745098039215686)",
                        cursor: "pointer",
                      }}
                    >
                      <div>
                        <FolderIcon
                          style={{ color: "rgba(var(--br-primary-rgb, 112,87,246), 0.6039215686274509)", fontSize: "35px" }}
                        />
                      </div>
                      <div style={{ fontSize: "12px" }}>
                        {fileId?.length < 10
                          ? fileId
                          : fileId?.slice(0, 10) + "..." || "Unnamed"}
                      </div>
                    </div>
                  ))
                : null}
              {openedFolders === null
                ? sorteddocuments && sorteddocuments.length > 0
                  ? sorteddocuments
                      .filter((doc) => doc.type === null)
                      .map((doc, index) => (
                        <div
                          className="border_change_hover"
                          style={{
                            padding: "20px",
                            borderRadius: "8px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            width:
                              window.innerWidth < 1200
                                ? `${window.innerWidth / 2 - 30}px`
                                : "120px",
                            height: "120px",
                            textAlign: "center",
                            border: "1px solid rgba(var(--br-primary-rgb, 112,87,246), 0.22745098039215686)",
                            cursor: "pointer",
                          }}
                          key={index}
                          onClick={(e) => {
                            e.preventDefault();
                            window.open(doc.url, "_blank");
                          }}
                        >
                          <div>
                            <FileCopyIcon
                              style={{ color: "rgba(var(--br-primary-rgb, 112,87,246), 0.2901960784313726)", fontSize: "24px" }}
                            />
                          </div>
                          <div style={{ fontSize: "12px" }}>
                            {doc?.file_name?.length < 10
                              ? doc?.file_name
                              : doc?.file_name?.slice(0, 10) + "..." ||
                                "Unnamed"}
                          </div>
                          <div style={{ fontSize: "9px" }}>
                            {formatDate(doc.created_at)}
                          </div>
                        </div>
                      ))
                  : null
                : openedFolders.map((doc, index) => (
                    <div
                      className="border_change_hover"
                      style={{
                        padding: "20px",
                        borderRadius: "8px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        width:
                          window.innerWidth < 1200
                            ? `${window.innerWidth / 2 - 30}px`
                            : "120px",
                        height: "120px",
                        textAlign: "center",
                        border: "1px solid rgba(var(--br-primary-rgb, 112,87,246), 0.22745098039215686)",
                        cursor: "pointer",
                      }}
                      key={index}
                      onClick={(e) => {
                        e.preventDefault();
                        window.open(doc.url, "_blank");
                      }}
                    >
                      <div>
                        <FileCopyIcon
                          style={{ color: "rgba(var(--br-primary-rgb, 112,87,246), 0.2901960784313726)", fontSize: "24px" }}
                        />
                      </div>
                      <div style={{ fontSize: "12px" }}>
                        {doc?.file_name?.length < 10
                          ? doc?.file_name
                          : doc?.file_name?.slice(0, 10) + "..." || "Unnamed"}
                      </div>
                      <div style={{ fontSize: "9px" }}>
                        {formatDate(doc.created_at)}
                      </div>
                    </div>
                  ))}
            </div>
          </div>
        ) : openedTab === 1 ? (
          <div className="sl-borrower-vault-summary"
            style={{
              width: "100%",
              background:
                window.innerWidth < 1200
                  ? "transparent"
                  : "var(--br-card-surface, transparent linear-gradient(180deg, #FFFFFFB3 0%, #FFFFFF00 100%) 0% 0% no-repeat padding-box)",
              borderRadius: "var(--br-card-radius, 10px)",
              marginTop: "5px",
              gap: "5px",
              padding: "20px",
              height:
                window.innerWidth < 1200
                  ? `calc(${window.innerHeight}px - 130px)`
                  : "calc(100% - 130px)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                paddingBottom: "15px",
              }}
            >
              <div
                style={{
                  color: "var(--br-text, #142C44CC)",
                  fontFamily: "Manrope,sans-serif",
                  fontWeight: "800",
                  fontSize: "18px",
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "10px",
                  justifyContent: "space-between",
                  width: "50%",
                }}
              >
                Upcoming Installments Due
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "15px",
                  alignItems: "center",
                  width: "50%",
                }}
              >
                <div
                  onClick={() => {
                    setExportCsvIsOpen(true);
                  }}
                  className="mui_button stepssss2"
                  style={{
                    color: "var(--br-primary, rgb(14, 90, 165))",
                    border: "2px solid var(--br-primary, rgb(14, 90, 165))",
                    fontWeight: 500,
                    fontSize: "14px",
                    padding: "5px 15px",
                    borderRadius: "7px",
                    marginLeft: "10px",
                    textAlign: "center",
                    cursor: "pointer",
                  }}
                >
                  Export CSV
                </div>
                <select
                  style={{
                    maxWidth: "150px",
                    color: "var(--br-primary, rgb(14, 90, 165))",
                    border: "2px solid var(--br-primary, rgb(14, 90, 165))",
                    fontWeight: 500,
                    fontSize: "14px",
                    padding: "5px 15px",
                    height: "34px",
                    borderRadius: "7px",
                    background: "transparent",
                  }}
                  onChange={(e) => {
                    setCurrentDisplayMonth(e.target.value);
                  }}
                  value={currentDisplayMonth}
                >
                  {financialSummaryMonth
                    ? Object.keys(financialSummaryMonth).map((month) => (
                        <option value={month}>{month}</option>
                      ))
                    : null}
                  <option value={currentMonth}>Current Month</option>
                </select>
              </div>
            </div>
            <div style={{ width: "100%", marginBottom: "15px" }}>
              {currentLoanData ? (
                <div
                  style={{
                    background: "var(--br-soft, #f0eeff)",
                    borderRadius: "6px",
                    padding: "10px 20px",
                    boxShadow: "var(--br-shadow, inset 4px 4px 10px rgba(0,0,0,0.2))",
                  }}
                >
                  <div
                    style={{
                      color: "var(--br-text, #142C44CC)",
                      fontFamily: "Manrope,sans-serif",
                      fontWeight: "600",
                      fontSize: "14px",
                    }}
                  >
                    Total Loan Outstanding
                  </div>
                  <div
                    style={{
                      color: "var(--br-text, #142C44CC)",
                      fontFamily: "Manrope,sans-serif",
                      fontWeight: "800",
                      fontSize: "28px",
                    }}
                  >
                    {currentLoanData.total_loan_outstanding}
                  </div>
                  <div style={{ display: "flex", marginTop: "15px" }}>
                    <div
                      style={{
                        height: "30px",
                        borderRadius: "6px",
                        width: "300px",
                        padding: "0px 2.5px",
                        boxShadow: "var(--br-shadow, 0px 0px 10px rgba(0,0,0,0.2))",
                        background: "rgba(256,256,256,1)",
                        position: "relative",
                      }}
                    >
                      <div
                        style={{
                          width: currentLoanData.percentage_of_loan_remaining,
                          height: "25px",
                          marginTop: "2.8px",
                          background: "rgba(var(--br-primary-rgb, 21,87,169), 0.604)",
                          borderRadius: "4.5px",
                        }}
                      />
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: "10%",
                          height: "100%",
                          width: "3px",
                          background: "rgba(256,256,256,1)",
                          transform: "translate(-50%,0)",
                        }}
                      />
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: "20%",
                          height: "100%",
                          width: "3px",
                          background: "rgba(256,256,256,1)",
                          transform: "translate(-50%,0)",
                        }}
                      />
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: "30%",
                          height: "100%",
                          width: "3px",
                          background: "rgba(256,256,256,1)",
                          transform: "translate(-50%,0)",
                        }}
                      />
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: "40%",
                          height: "100%",
                          width: "3px",
                          background: "rgba(256,256,256,1)",
                          transform: "translate(-50%,0)",
                        }}
                      />
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: "50%",
                          height: "100%",
                          width: "3px",
                          background: "rgba(256,256,256,1)",
                          transform: "translate(-50%,0)",
                        }}
                      />
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: "60%",
                          height: "100%",
                          width: "3px",
                          background: "rgba(256,256,256,1)",
                          transform: "translate(-50%,0)",
                        }}
                      />
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: "70%",
                          height: "100%",
                          width: "3px",
                          background: "rgba(256,256,256,1)",
                          transform: "translate(-50%,0)",
                        }}
                      />
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: "80%",
                          height: "100%",
                          width: "3px",
                          background: "rgba(256,256,256,1)",
                          transform: "translate(-50%,0)",
                        }}
                      />
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: "90%",
                          height: "100%",
                          width: "3px",
                          background: "rgba(256,256,256,1)",
                          transform: "translate(-50%,0)",
                        }}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      color: "var(--br-text, #142C44CC)",
                      fontFamily: "Manrope,sans-serif",
                      fontWeight: "600",
                      fontSize: "14px",
                      marginTop: "15px",
                    }}
                  >
                    Paid {currentLoanData.percentage_of_loan_remaining} of Total
                    Loan Amount of {currentLoanData.total_loan_amount}
                  </div>
                </div>
              ) : null}
            </div>
            <div
              style={{
                height: "60%",
                overflowY: "auto",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                width: "100%",
              }}
              className="stepssss3 sl-borrower-vault-table"
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  opacity: 0.5,
                }}
              >
                <div style={{ width: "20%" }}>Lender</div>
                <div style={{ width: "10%" }}>Disb. Date</div>
                <div style={{ width: "10%" }}>Facility Limit</div>
                <div style={{ width: "10%" }}>Monthly Inst.</div>
                <div style={{ width: "10%" }}>Tenor</div>
                <div style={{ width: "10%" }}>Int. Rate</div>
                <div style={{ width: "10%" }}>Processing Fee</div>
                <div style={{ width: "10%" }}>Due Date</div>
                <div style={{ width: "20%" }}>Status</div>
              </div>
              {financialSummaryMonth &&
              currentDisplayMonth !== "" &&
              financialSummaryMonth[currentDisplayMonth] &&
              financialSummaryMonth[currentDisplayMonth].length > 0 ? (
                financialSummaryMonth[currentDisplayMonth].map(
                  (data, index) => (
                    <div
                      key={index}
                      className="mui_button"
                      onClick={() => setOpenLoanData(data)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        border: "1px solid $142C442A",
                        paddingBottom: "10px",
                        borderBottom:
                          financialSummaryMonth[currentDisplayMonth].length -
                            1 !==
                          index
                            ? "1px solid #142C442A"
                            : "none",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          width: "20%",
                        }}
                      >
                        <div
                          style={{
                            background: "rgba(var(--br-primary-rgb, 112,87,246), 0.6039215686274509)",
                            color: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "50px",
                            height: "50px",
                            borderRadius: "7px",
                          }}
                        >
                          {getInitials(data.lender)}
                        </div>
                        <div
                          style={{
                            textAlign: "left",
                            width: "calc(100% - 60px)",
                          }}
                        >
                          <div style={{ fontSize: "16px", fontWeight: 600 }}>
                            {data.lender}
                          </div>
                          <div>{data.typeoffacility}</div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "10%",
                        }}
                      >
                        {data.disbursementdate}
                      </div>
                      <div
                        style={{
                          width: "10%",
                        }}
                      >
                        {data.facilitylimit}
                      </div>
                      <div
                        style={{
                          width: "10%",
                        }}
                      >
                        {data.monthylyinstallment}
                      </div>
                      <div
                        style={{
                          width: "10%",
                        }}
                      >
                        {data.tenor}
                      </div>
                      <div
                        style={{
                          width: "10%",
                        }}
                      >
                        {data.interestrate}
                      </div>
                      <div
                        style={{
                          width: "10%",
                        }}
                      >
                        {data.processingfee}
                      </div>
                      <div
                        style={{
                          width: "10%",
                        }}
                      >
                        {data.dueDate ? formatDate(data.dueDate) : null}
                      </div>
                      <div
                        style={{
                          background: "rgba(var(--br-primary-rgb, 112,87,246), 0.6039215686274509)",
                          color: "white",
                          padding: "6px 15px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "7px",
                          width: "20%",
                          textAlign: "center",
                        }}
                      >
                        {data.currentRepayment + " Paid"}
                        <br />
                        {"(Loan Bal: S$ " +
                          (data.bankbool === "Bank Loan"
                            ? data.remainingBalance?.toLocaleString("en-SG", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : data.paidRepayment?.toLocaleString("en-SG", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })) +
                          ")"}
                      </div>
                    </div>
                  )
                )
              ) : (
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    opacity: 0.4,
                  }}
                >
                  <HourglassDisabledIcon
                    style={{ color: "var(--br-text, #142C44CC)", fontSize: "80px" }}
                  />
                  <div
                    style={{
                      width: "70%",
                      marginTop: "20px",
                      textAlign: "center",
                    }}
                  >
                    You currently do not have any payments in the selected
                    month.
                  </div>
                </div>
              )}
            </div>
            <div
              style={{
                display: "flex",
                width: "100%",
                alignItems: "flex-start",
                justifyContent: "space-between",
                borderTop: "1px solid var(--br-text, #142C44CC)",
                paddingTop: "10px",
              }}
            >
              <div style={{ width: "35%", fontSize: "12px" }}>
                Disclaimer: The above data assumes timely monthly repayments.
                Any deferred payments, restructures, or loan redemptions may not
                be accurately reflected.
              </div>
              <div
                style={{
                  textAlign: "right",
                  width: "45%",
                }}
              >
                Total Payments this month:{" "}
                <span
                  style={{
                    fontSize: "30px",
                    fontWeight: 700,
                    marginLeft: "20px",
                  }}
                >
                  {financialSummaryMonth &&
                  currentDisplayMonth !== "" &&
                  financialSummaryMonth[currentDisplayMonth] &&
                  financialSummaryMonth[currentDisplayMonth].length > 0
                    ? financialSummaryMonth[currentDisplayMonth]
                        ?.reduce(
                          (sum, item) =>
                            sum +
                            parseFloat(
                              item.monthylyinstallment.replace(/[^\d.-]/g, "")
                            ),
                          0
                        )
                        ?.toLocaleString("en-US", {
                          style: "currency",
                          currency: "SGD",
                        }) || "SGD 0"
                    : "SGD 0"}
                </span>
              </div>
            </div>
          </div>
        ) : null}
      </div>
      <Tour
        accentColor="#7057F6"
        steps={tourSteps}
        style={{ color: "black" }}
        isOpen={isTourOpen2}
        onRequestClose={() => {
          setIsTourOpen2(false);
          setOpenTab(1);
          if (isSampleData) {
            setMyFinancialSummary(null);
            setFinancialSummaryMonth(null);

            setCurrentLoanData({
              total_loan_amount: `S$ 0`,
              total_paid_off_amount: `S$ 0`,
              total_loan_outstanding: `S$ 0`,
              percentage_of_loan_remaining: `0%`,
            });
          }
        }}
        getCurrentStep={(step) => {
          if (step === 3) {
            setOpenTab(0);
          }
        }}
      />
    </div>
  );
};

export default DocumentVault;
